import {createSelector} from '@ngrx/store';
import {
  SEARCH_RESULT_UPDATE,
  SEARCH_RESULT_ADD,
  SEARCH_RESULT_REMOVE,
  ACTIVE_SEARCH_SET,
  ACTIVE_SEARCH_REMOVE,
  SHIPMENT_ADD,
  SHIPMENT_REMOVE,
  SHIPMENT_UPDATE,
  SEARCH_RESULTS_REMOVE,
  ORDER_CREATION_CLEAR,
  ORDER_SUMMARY_CLEAR,
} from '@store/actions';
import {ActionWithPayload, AppState} from './index';
import {Product} from '@models/product.interface';
import {Shipment} from '@models/shipment.interface';
import {selectInitialInfo} from '@store/reducers/initial-info.reducer';
import {CLEAR_ORDER_CREATION_STATE} from '@store/actions/order-creation.action';
import 'rxjs/add/operator/map';

export interface SearchResult {
  id: string;
  products: Product[];
  params: Object;
  loaded: boolean;
  loading: boolean;
  saved: boolean;
  search_id: number;
}

export interface OrderCreationState {
  searchResults: SearchResult[];
  activeSearchId: string;
  shipments: {[key: string]: Shipment};
  order: any;
}

export function orderCreationReducer (
  state = {
    searchResults: [],
    shipments: {},
    activeSearchId: null,
  }, action: ActionWithPayload<any>) {
  switch (action.type) {

    case SEARCH_RESULT_UPDATE:
      const currentSearchResult = {...state.searchResults.find(searchResult => searchResult.id === action.payload.id)};
      Object.keys(action.payload).forEach(key => {
        currentSearchResult[key] = action.payload[key];
      });
      return {
        ...state,
        searchResults: [
          ...state.searchResults.filter(searchResult => searchResult.id !== action.payload.id),
          currentSearchResult
        ],
      };

    case SEARCH_RESULT_ADD:
      const exists = state.searchResults.find(result => result.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        searchResults: [
          ...state.searchResults,
          { ...action.payload }
        ]
      };

    case SEARCH_RESULT_REMOVE:
      return {
        ...state,
        searchResults: state.searchResults.filter(searchResult => searchResult.id !== action.payload.id),
        activeSearchId: state.activeSearchId === action.payload.id ? null : state.activeSearchId,
        // shipments: state.shipments.filter(())
      };
    case SEARCH_RESULTS_REMOVE:
      return {
        ...state,
        searchResults: []
      };
    case ACTIVE_SEARCH_SET:
      return {
        ...state,
        activeSearchId: action.payload.activeSearchId,
      };

    case ACTIVE_SEARCH_REMOVE:
      return {
        ...state,
        activeSearchId: null
      };

    case SHIPMENT_ADD:
    case SHIPMENT_UPDATE:
      return {
        ...state,
        shipments: {
          ...state.shipments,
          [action.payload.shipment.id]: action.payload.shipment,
        }
      };

    case SHIPMENT_REMOVE:
      const deletedShipmentId = action.payload.id;
      const {[deletedShipmentId]: deletedShipment, ...shipments} = state.shipments;
      return {
        ...state,
        shipments
      };

    case ORDER_CREATION_CLEAR:
      return {
        searchResults: [],
        shipments: {},
        activeSearchId: null,
      };

    case ORDER_SUMMARY_CLEAR:
      return {
        ...state,
        shipments: {},
        activeSearchId: null
      };

    case CLEAR_ORDER_CREATION_STATE:
      return {
        searchResults: [],
        shipments: {},
        activeSearchId: null,
      };

    default:
      return state;
  }
}


export const selectOrderCreation = (state: AppState) => state.orderCreation;

export const selectShipments = createSelector(
  selectOrderCreation,
  (state: OrderCreationState) =>
    Object.keys(state.shipments).map(id => {
      return {id, ...state.shipments[id]};
    })
);

export const selectSearchResults = createSelector(
  selectOrderCreation,
  (state: OrderCreationState) => state.searchResults
);

export const selectActiveSearchId = createSelector(
  selectOrderCreation,
  (state: OrderCreationState) => state.activeSearchId
);

export const selectShipmentProductTerms = createSelector(
  selectShipments,
  selectInitialInfo,
  (shipments, {product_terms}) => {
    const shipmentProductTerms = [];
    Object.values(shipments).forEach(({details}) => {
      const term = product_terms.find(({products}) => !!(products.find(id => id == details.product_id)));
      if (term && !shipmentProductTerms.find(({title}) => title === term.title)) {
        shipmentProductTerms.push(term);
      }
    });
    return shipmentProductTerms;
  }
);



// WEBPACK FOOTER //
// ./src/app/store/reducers/order-creation.reducer.ts